<template>
    <div class="agendamento__badge__container success">
        <b-badge :class="agendamentoClass">
            <div class="agendamento__badge__inner__container ">
                <i class="agendamento__badge__icon fas fa-calendar-alt"></i>
                <p class="agendamento__badge__text">{{ formattedDate }}</p>
            </div>
        </b-badge>
    </div>
</template>
<script>

export default {
  name: 'BadgeAgendamento',
  data () {
    return {
      months: ['JAN', 'FEV', 'MAR', 'ABR', 'MAIO', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']
    }
  },
  props: {
    date: {
      type: String,
      required: true,
      default: null
    }
  },
  computed: {
    nextAgendamento () {
      return this.moment.utc(this.date).format('DD/MM/YYYY HH:mm')
    },
    agendamentoVencido () {
      const dataAtual = new Date()
      let ag = this.moment(this.nextAgendamento, 'DD/MM/YYYY hh:mm')
      let hoje = this.moment(dataAtual, 'DD/MM/YYYY hh:mm')
      return hoje.diff(ag, 'minutes') > 0
    },
    isNextAgendamentoToday () {
      let dataAtual = this.moment().format('DD/MM/YYYY')
      let ag = this.moment(this.nextAgendamento, 'DD/MM/YYYY')
      let hoje = this.moment(dataAtual, 'DD/MM/YYYY')
      let dataDiff = hoje.diff(ag, 'days')

      return dataDiff === 0 || !this.nextAgendamento
    },
    agendamentoClass () {
      if (this.agendamentoVencido) {
        return 'danger'
      } else if (this.isNextAgendamentoToday) {
        return 'success'
      } else {
        return 'default'
      }
    },
    formattedDate () {
      const date = new Date(this.date)
      const month = this.months[date.getUTCMonth()]
      const day = date.getUTCDate()
      const hours = date.getUTCHours()
      const minutes = date.getUTCMinutes().toString().padStart(2, '0')
      return `${month} ${day}, ${hours}:${minutes}`
    }
  }
}
</script>
<style lang="scss">
.agendamento__badge{

    &__inner__container{
        display: flex;
        gap: .5rem;
        padding: .1rem .3rem;

        p{
            margin: 0;
        }
    }

    &__container{
        font-size: .9rem;
        font-weight: bold;

        .success{
            color: #fff;
            background: #61BD4F;
        }
        .default{
            color: #686868;
            background: transparent;
        }
        .danger{
            color: #fff;
            background: #AE2A19;
        }
    }
}
</style>

<!-- <template>
    <div :class="agendamentoClass">
      <span v-if="nextAgendamento">
        <i title="Próximo agendamento" class="far fa-calendar-alt"></i> {{ nextAgendamento }}
      </span>
      <span v-else>N/D</span>
    </div>
  </template>

  <script>
  export default {

  </script> -->



// WEBPACK FOOTER //
// src/components/UI/badge-agendamento/BadgeAgendamento.vue